import React from 'react'
import styled from 'styled-components'

export default function GTranslate() {
  return (
      <GTStyled className="bg-white">
          <div id="google_translate_element"></div>
      </GTStyled>
  )
}


const GTStyled = styled.div`
  margin-bottom: 10px;
//   background: pink;
  /* gOOgle Translate Styles */
  #google_translate_element {
    // background: #eee;
    bottom: 20px;
    z-index: 99999;
    text-align: center;
    margin-top: 1rem;
    padding: 10px 0;
  }

  .loPBee .goog-te-gadget .goog-te-combo {
    border-radius: 11px;
    padding: 3px;
    // background-color: #fff;
    font-size: 10px;

    &:focus {
      outline: none;
    }
  }

  .goog-te-gadget .goog-te-combo {
    /* margin: 4px 0; */
    border-radius: 11px;
   
    padding: 3px;
    background-color: #fff;
    font-size: 11px;
  }

  /* google text */
  .goog-logo-link,
  .goog-logo-link:link,
  .goog-logo-link:visited,
  .goog-logo-link:hover,
  .goog-logo-link:active {
    font-size: 10px;
    font-weight: bold;
    color: #444;
    text-decoration: none;
    /* display: none; */
  }

  #google-text-writeup {
    font-size: 10px;
    padding: 0 1rem;
    text-align: center;
  }
`;